import styled from 'styled-components';
import { Typography, Link } from '@material-ui/core';

export const Banner = styled.article`
	width: 100%;
	background-color: #3b3b3b;
	position: fixed;
	bottom: 0px;
	z-index: 2;
	display: ${props => props.display};
`;

export const StyledTypography = styled(Typography)`
	&.MuiTypography-paragraph {
		${props => props.theme.breakpoints.up('md')} {
			margin-bottom: 0px;
		}
	}
`;

export const StyledContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;

	${props => props.theme.breakpoints.up('xs')} {
		flex-direction: column;
		padding: 20px 20px 80px 20px;
	}

	${props => props.theme.breakpoints.up('md')} {
		flex-direction: row;
		padding: 40px 320px 40px 100px;
		& > button {
			margin-left: 12px;
		}
	}
`;

export const StyledLink = styled(Link)`
	color: #fff;
`;
